class Auth {
  static _user = null;
  static _appcuesIdentified = false;

  /**
   * Authenticate a user. Save a token string in Local Storage
   *
   * @param {string} token
   */
  static authenticateUser(token, user_id, position, game_id, course_id) {
    sessionStorage.setItem("token", token);
    sessionStorage.setItem("user_id", user_id);
    sessionStorage.setItem("position", position);
    sessionStorage.setItem("game_id", game_id);
    sessionStorage.setItem("course_id", course_id);

    if (window && window.Appcues && Auth._appcuesIdentified === false) {
      window.Appcues.identify(user_id);
      Auth._appcuesIdentified = true;
    }
  }

  /**
   * Check if a user is authenticated - check if a token is saved in Local Storage
   *
   * @return {boolean}
   */
  static isUserAuthenticated() {
    return (
      sessionStorage.getItem("token") !== null &&
      sessionStorage.getItem("user_id") !== null &&
      sessionStorage.getItem("position") !== null &&
      sessionStorage.getItem("game_id") !== null &&
      sessionStorage.getItem("course_id") !== null &&
      localStorage.getItem("players_data") !== null &&
      localStorage.getItem("teams_data") !== null
    );
  }

  static setPlayerRoles(roles) {
    sessionStorage.setItem("player_roles", JSON.stringify(roles));
  }

  static getPlayerRoles(roles) {
    return JSON.parse(sessionStorage.getItem("player_roles", "[]"));
  }

  /**
   * Deauthenticate a user. Remove a token from Local Storage.
   */
  static deauthenticateUser() {
    if (Auth.getPosition() === "Instructor") {
      sessionStorage.removeItem("team_id");
    }
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("user_id");
    sessionStorage.removeItem("position");
    sessionStorage.removeItem("game_id");
    sessionStorage.removeItem("course_id");
    sessionStorage.removeItem("player_roles");
    localStorage.removeItem("finance-unaccepted-decisions");
    localStorage.removeItem("development-unaccepted-decisions");
    localStorage.removeItem("marketing-unaccepted-decisions");
    localStorage.removeItem("operations-unaccepted-decisions");
    localStorage.removeItem("players_data");
    localStorage.removeItem("teams_data");
    Auth._user = null;
    Auth._appcuesIdentified = false;
  }

  /**
   * Get menu state
   *
   * @return {bool}
   */
  static getMenuState() {
    let menuState = localStorage.getItem('menu_state');
    if (typeof menuState === 'string') {
      if (menuState === 'true') {
        menuState = true;
      } else if (menuState === 'false') {
        menuState = false;
      } else {
        menuState = null;
      }
    }

    return menuState === null || typeof menuState === 'undefined' ? true : menuState;
  }

  /**
   * Set menu state
   */
  static setMenuState(value) {
    localStorage.setItem('menu_state', value)
  }

  /**
   * Get a token value.
   *
   * @return {string}
   */
  static getToken() {
    return sessionStorage.getItem("token");
  }

  /**
   * Set a token value.
   */
  static setToken(value) {
    sessionStorage.setItem("token", value);
  }

  /**
   * Get a user_id value.
   *
   * @return {integer}
   */
  static getUserId() {
    return sessionStorage.getItem("user_id");
  }

  /**
   * Set a user_id value.
   */
  static setUserId(value) {
    sessionStorage.setItem("user_id", value);

    if (window && window.Appcues && Auth._appcuesIdentified === false) {
      window.Appcues.identify(value);
      Auth._appcuesIdentified = true;
    }
  }

  /**
   * Get user role.
   *
   * @return {string}
   */
  static getRole() {
    const playerRoles = Auth.getPlayerRoles();
    const userId = Number(Auth.getUserId());
    const player = playerRoles ? playerRoles.find(i => Number(i.user.id) === userId) : null;

    return player ? player.role.toUpperCase() : Auth._user ? Auth._user.role : '';
  }

  /**
   * Set temporary user
   */
  static setTemporaryUser(data) {
    sessionStorage.setItem("temporary_user", JSON.stringify(data));
  }

  /**
   * Get temporary user
   *
   * @return {object|null}
   */
  static getTemporaryUser() {
    try {
      return JSON.parse(sessionStorage.getItem("temporary_user"));
    } catch (err) {
      return null;
    }
  }

  /**
   * Get user team.
   *
   * @return {integer}
   */
  static getTeamId() {
    const teamId = Auth._user ? Auth._user.team : null;
    const teamId2 = parseInt(sessionStorage.getItem("team_id"), 10);

    return teamId ? teamId : isNaN(teamId2) ? 0 : teamId2;
  }

  /**
   * Set a team id value.
   */
  static setTeamId(value) {
    sessionStorage.setItem("team_id", value);
  }

  /**
   * Get a position of the user
   *
   * @return {string}
   */
  static getPosition() {
    return sessionStorage.getItem("position");
  }

  /**
   * Set a position value.
   */
  static setPosition(value) {
    sessionStorage.setItem("position", value);
  }

  /**
   * Get current game id
   *
   * @return {integer}
   */
  static getGameId() {
    const game_id = parseInt(sessionStorage.getItem("game_id"), 10);

    return isNaN(game_id) ? 0 : game_id;
  }

  /**
   * Set a game id value.
   */
  static setGameId(value) {
    sessionStorage.setItem("game_id", value);
  }

  /**
   * Get current course id
   *
   * @return {integer}
   */
  static getCourseId() {
    const course_id = parseInt(sessionStorage.getItem("course_id"), 10);

    return isNaN(course_id) ? 0 : course_id;
  }

  /**
   * Set a course_id value.
   */
  static setCourseId(value) {
    sessionStorage.setItem("course_id", value);
  }

  /**
   * Check is current user was paid
   *
   * @return {boolean}
   */
  static isPaid() {
    return Auth._user ? Auth._user.is_paid : false;
  }

  /**
   * Get current user data
   *
   * @return {object}
   */
  static getUser() {
    return Auth._user;
  }

  /**
   * Get correct role path
   *
   * @return {string}
   */
  static getRolePath() {
    let current_role = Auth.getRole().toLowerCase();

    if (current_role === "fi") {
      current_role = "fn";
    }

    if (
      current_role !== "ceo" &&
      current_role !== "pd" &&
      current_role !== "pm" &&
      current_role !== "op" &&
      current_role !== "fn"
    ) {
      current_role = "ceo";
    }

    return current_role;
  }

  static getUserDataRequest() {
    const user_id = Auth.getUserId();

    if (!user_id) {
      return null;
    }

    return `${process.env.REACT_APP_API_URL}users/${user_id}/get_info/`;
  }

  static setUserData(data) {
    Auth._user = data;
  }
}

export default Auth;



// WEBPACK FOOTER //
// ./src/routes/Auth.js